import { styled } from "styled-components";
import { Flex, Constants, Space } from "@nubeteck/components";

const { device } = Constants;

export const CurrentTermGradesContainer = styled(Flex)`
  flex-direction: column;
  gap: 32px;
`;

export const CurrentTermGradesContent = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 32px;

  @media ${device.tablet} {
    flex-direction: row;
  }
  @media ${device.laptop} {
    gap: 64px;
  }
`;

export const GradesContainer = styled(Flex)`
  flex: 2;
  flex-direction: column;
  gap: 24px;
  text-align: center;

  @media ${device.tablet} {
    text-align: left;
  }
`;

export const CardAndButtonContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media ${device.tablet} {
    align-items: flex-end;
  }
`;

export const GradesDocumentContainer = styled(Flex)`
  width: 100%;
  min-height: 400px;
  border-radius: 15px;
  background: #fff;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
`;

export const GradesSelectionCardBody = styled(Flex)`
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media ${device.laptop} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const GradesSelectionCardBodySpace = styled(Space)`
  flex-wrap: wrap !important;
  justify-content: center !important;

  @media ${device.laptop} {
    justify-content: flex-end !important;
  }
`;
